/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as RegisterRouteImport } from "./routes/register"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app/index"
import { Route as AppStatistikRouteImport } from "./routes/_app/statistik"
import { Route as AppProfilRouteImport } from "./routes/_app/profil"
import { Route as AppHistorikRouteImport } from "./routes/_app/historik"
import { Route as AppProfilBarnChildIdRouteImport } from "./routes/_app/profil_.barn.$childId"

const RegisterRoute = RegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const AppStatistikRoute = AppStatistikRouteImport.update({
  id: "/statistik",
  path: "/statistik",
  getParentRoute: () => AppRoute,
} as any)
const AppProfilRoute = AppProfilRouteImport.update({
  id: "/profil",
  path: "/profil",
  getParentRoute: () => AppRoute,
} as any)
const AppHistorikRoute = AppHistorikRouteImport.update({
  id: "/historik",
  path: "/historik",
  getParentRoute: () => AppRoute,
} as any)
const AppProfilBarnChildIdRoute = AppProfilBarnChildIdRouteImport.update({
  id: "/profil_/barn/$childId",
  path: "/profil/barn/$childId",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/historik": typeof AppHistorikRoute
  "/profil": typeof AppProfilRoute
  "/statistik": typeof AppStatistikRoute
  "/profil/barn/$childId": typeof AppProfilBarnChildIdRoute
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/historik": typeof AppHistorikRoute
  "/profil": typeof AppProfilRoute
  "/statistik": typeof AppStatistikRoute
  "/": typeof AppIndexRoute
  "/profil/barn/$childId": typeof AppProfilBarnChildIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/_app/historik": typeof AppHistorikRoute
  "/_app/profil": typeof AppProfilRoute
  "/_app/statistik": typeof AppStatistikRoute
  "/_app/": typeof AppIndexRoute
  "/_app/profil_/barn/$childId": typeof AppProfilBarnChildIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/register"
    | "/historik"
    | "/profil"
    | "/statistik"
    | "/profil/barn/$childId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/register"
    | "/historik"
    | "/profil"
    | "/statistik"
    | "/"
    | "/profil/barn/$childId"
  id:
    | "__root__"
    | "/_app"
    | "/login"
    | "/register"
    | "/_app/historik"
    | "/_app/profil"
    | "/_app/statistik"
    | "/_app/"
    | "/_app/profil_/barn/$childId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/register": {
      id: "/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/statistik": {
      id: "/_app/statistik"
      path: "/statistik"
      fullPath: "/statistik"
      preLoaderRoute: typeof AppStatistikRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/profil": {
      id: "/_app/profil"
      path: "/profil"
      fullPath: "/profil"
      preLoaderRoute: typeof AppProfilRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/historik": {
      id: "/_app/historik"
      path: "/historik"
      fullPath: "/historik"
      preLoaderRoute: typeof AppHistorikRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/profil_/barn/$childId": {
      id: "/_app/profil_/barn/$childId"
      path: "/profil/barn/$childId"
      fullPath: "/profil/barn/$childId"
      preLoaderRoute: typeof AppProfilBarnChildIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppHistorikRoute: typeof AppHistorikRoute
  AppProfilRoute: typeof AppProfilRoute
  AppStatistikRoute: typeof AppStatistikRoute
  AppIndexRoute: typeof AppIndexRoute
  AppProfilBarnChildIdRoute: typeof AppProfilBarnChildIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHistorikRoute: AppHistorikRoute,
  AppProfilRoute: AppProfilRoute,
  AppStatistikRoute: AppStatistikRoute,
  AppIndexRoute: AppIndexRoute,
  AppProfilBarnChildIdRoute: AppProfilBarnChildIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
